export default "__VITE_ASSET__88e9e756__"